import React from "react";
import { Box } from "@mui/material";
import { customColour } from "../data/colour";

const Section = ({
  id,
  children,
  color = customColour.white,
  background = `linear-gradient(135deg, ${customColour.greyMix}, ${customColour.black})`,
  backgroundColor = "none",
  image,
  width = "60%",
  padding = "5rem",
  borderTop,
  borderBottom,
}) => {
  return (
    <Box
      id={id}
      sx={{
        height: "auto",
        background: background,
        backgroundColor: backgroundColor,
        backgroundImage: `url(${image})`,
        borderTop: borderTop,
        borderBottom: borderBottom,
        backgroundSize: "cover",
        color: color,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        overflow: "hidden",
      }}
    >
      <Box sx={{ width: width, paddingTop: padding, paddingBottom: padding }}>
        {children}
      </Box>
    </Box>
  );
};

export default Section;
